<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading">
  <div class="card-container mat-elevation-z1">
    <div class="card-content">
      <app-patient-search-component
        id="patientSearch"
        (selected)="onPatientSelected($event)"
        #patientSearch
      ></app-patient-search-component>
      <div *ngIf="patient || patientView">
        <app-patient-view-component
          id="patientViewComponent"
          [patientview]="patientView"
          [patient]="patient"
          #patientViewComponent
        ></app-patient-view-component>
      </div>
    </div>

    <div class="clearfix">
      <div class="pull-right margin-right-medium">
        <button class="card-inline" (click)="cancel()" type="button" mat-button>CANCELAR</button>
      </div>
      <div class="card-footer">
        <button color="primary" mat-flat-button matStepperNext type="submit">
          SIGUIENTE
        </button>
      </div>
    </div>
  </div>
</div>
